module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAu4AAAAEBAMAAAAjc6c0AAAABGdBTUEAALGPC/xhBQAAADBQTFRFGI/JLJnOZbXbstrt5Vp+6GiJ6YA+64tO7Pb77pGp8at/98jU+NW//fL1/vXw////iKP+mAAAAHtJREFUOMtjYIAA4f9I4FUaBqhBlr/pggGikeWbGDDAqPlYzWfqRxL+U4ZhbNZ7JPnfIRjGet5Hkv8sgOHsUfOxms9ojyT8bxmGsennkeT/TsEw1nU/kvwPBQxnj5qP3XwN5FxwHDMXrUOW34qZi+Yiyxti5tJR89HNBwDF5y+m+sNlKQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/bg_address_line@2x.png
// module id = yD4C
// module chunks = 0